import script from "./GraficoVendite.vue?vue&type=script&setup=true&lang=js"
export * from "./GraficoVendite.vue?vue&type=script&setup=true&lang=js"

import "./GraficoVendite.vue?vue&type=style&index=0&id=6fe7e9ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe7e9ce"]])

export default __exports__